import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { CartQuickOrderComponent } from './cart-quick-order.component';

@NgModule({
  imports: [CommonModule, I18nModule, RouterModule, UrlModule, CartQuickOrderComponent],
  exports: [CartQuickOrderComponent],
})
export class CartQuickOrderModule {}
